import axios from 'axios';
import { REACT_APP_API } from '../../config';

export default async function getSalesChannel() {

  try {
    return await axios.get(`${REACT_APP_API}/integrations/salesChannel`);
  } catch (error) {
    // Si vuelve un error con mensaje mensaje del backend, se usa ese mensaje
    if(error?.response?.data?.message) error.message = error.response.data.message;
    throw error;
  }

}
